// Transient per-field messages emitted by DateTimePicker when its sibling
// value was automatically adjusted (swap, peerMaxRange cap, …).
//
// Shape: { [`${formName}::${fieldName}`]: { kind, trigger_label, range } }
//   - kind: 'swap_before' | 'swap_after' | 'range_before' | 'range_after'
//   - trigger_label: user-facing label of the field that caused the adjustment
//   - range: humanised duration string (only for `range_*` kinds)
//
// Messages are cleared as soon as the user types again in the adjusted field.

const SET   = 'kronos/dtpAdjustments/SET';
const CLEAR = 'kronos/dtpAdjustments/CLEAR';

const key_of = (form, field) => `${form}::${field}`;

export const setDtpAdjustmentMessage = (form, field, message) =>
    ({ type: SET, form, field, message });

export const clearDtpAdjustmentMessage = (form, field) =>
    ({ type: CLEAR, form, field });

export default function dateTimePickerAdjustments(state = {}, action) {
    switch (action.type) {
        case SET: {
            if (!action.form || !action.field || !action.message)
                return state;
            return { ...state, [key_of(action.form, action.field)]: action.message };
        }
        case CLEAR: {
            if (!action.form || !action.field)
                return state;
            const k = key_of(action.form, action.field);
            if (!(k in state))
                return state;
            const next = { ...state };
            delete next[k];
            return next;
        }
        default:
            return state;
    }
}
